import React from "react";
import styles from "./News.module.scss";
import { motion } from "framer-motion";

const News = () => {
  const hasNews = false; // Trenutno nema novosti

  // Animacija za učitavanje placeholdera
  const loadingAnimation = {
    initial: { opacity: 0.5, y: 10 },
    animate: { opacity: 1, y: 0 },
    transition: { repeat: Infinity, repeatType: "reverse", duration: 1, ease: "easeInOut" },
  };

  return (
    <motion.section
      className={styles.news}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className={styles.title}>Novosti</h2>

      {hasNews ? (
        // Ako ima novosti, prikaži ih ovde
        <div className={styles.newsList}>
          <p>Ovdje će biti prikazane novosti.</p>
        </div>
      ) : (
        // Ako nema novosti, prikaži poruku i animirane placeholdere
        <div className={styles.noNews}>
          <p className={styles.noNewsMessage}>Trenutno nema novosti. Proverite kasnije!</p>

          {/* Placeholder sekcije sa animacijom */}
          <motion.div className={styles.placeholder} {...loadingAnimation} />
          <motion.div className={styles.placeholder} {...loadingAnimation} />
          <motion.div className={styles.placeholder} {...loadingAnimation} />
        </div>
      )}
    </motion.section>
  );
};

export default News;